module.exports = __webpack_public_path__ + "static/16-9794367ce751841ec67630979dd8a0d3.jpeg";